var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../../const/endpoints';
var queryFnFactory = function (config, keyProps, headers) {
    if (headers === void 0) { headers = {}; }
    var fetchWrapper = getFetchWrapper(config);
    return function () {
        var params = new URLSearchParams({
            'cipher.accountId': keyProps.accountId
        });
        if (keyProps.accountIdType) {
            params.set('accountIdType', keyProps.accountIdType);
        }
        return fetchWrapper("".concat(ENDPOINTS.changePaymentDueDate, "?").concat(params), {
            method: 'GET',
            headers: __assign({}, headers)
        });
    };
};
export default queryFnFactory;
